import React, {useState, useEffect} from 'react';
import {
   Image,
   ImageBackground,
   Text,
   View,
   Dimensions,
   TouchableOpacity,
   StyleSheet,
   FlatList,
   Platform,
} from 'react-native';
// import {AnimatedCircularProgress} from 'react-native-circular-progress';
import UICircularProgress from '../../components/circular-progress';
import {
   primaryState500,
   primaryColor900,
   white,
   base100,
   overAllPercent,
   FONT_FAMILY_REGULAR,
   getFullName,
   getNorcatId,
   getQRCode,
   GET_ADVERSTISEMENT,
   appBackgroundWhiteBG,
   primaryColor500,
   isWeb,
   isWindows,
   isMobile,
   isMacOS,
} from '../../utils/utils';
// import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import ViewBarcode from '../../utils/ViewBarcode';
import logger from '../../utils/logger';
import {apiGetRequest} from '../../service/network_access';
import {AdevertisementItem} from './AdvertisementItem';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import ProgressBar from './ProgressBar';

const DashboardRightPanel = props => {
   const [advertisementList, setAdvertisementList] = useState([]);
   const windowHeight = window.innerHeight ?? Dimensions.get('window').height;
   const navigation = useNavigation();
   const isScreenFocused = useIsFocused();

   // const posterWidth =
   const [posterWidth, setPosterWidth] = useState([]);
   const [posterHeight, setPosterHeight] = useState([]);
   const [windowDimensions, setWindowDimensions] = useState(
      Dimensions.get('window'),
   );
   useEffect(() => {
      const deviceHeightForWeb =
         windowHeight < 780
            ? // Medium size Desktop/Tablet
              windowHeight < 680
               ? windowHeight < 600
                  ? windowHeight * 0.27
                  : windowHeight * 0.325
               : windowHeight < 701
               ? windowHeight * 0.35
               : windowHeight < 750
               ? windowHeight * 0.415
               : windowHeight * 0.367
            : // Large size Desktop
            windowHeight > 1000
            ? windowHeight * 0.5
            : windowHeight * 0.45;
      const handleResize = () => {
         setWindowDimensions(Dimensions.get('window'));
      };
      const {width, height} = windowDimensions;
      const imgWidth = width > height ? width : height;
      if (!isWindows) {
         setPosterWidth(
            isWeb
               ? window.innerWidth * 0.3
               : isMacOS
               ? imgWidth * 0.29
               : imgWidth * 0.28,
         );
      }

      setPosterHeight(isWeb && deviceHeightForWeb + 290);
      Dimensions.addEventListener('change', handleResize);
      return () => {
         Dimensions.removeEventListener('change', handleResize);
      };
   }, [windowDimensions]);

   function getAdvertisementDataFromAPI() {
      apiGetRequest({url: GET_ADVERSTISEMENT})
         .then(res => {
            const advertisements = res.AdvertisementRecordsList;
            logger('advertisements:' + JSON.stringify(res));
            advertisements.length > 0
               ? setAdvertisementList(advertisements)
               : setAdvertisementList(placeHolderData);
         })
         .catch(error => {
            logger('error::', error);
         });
   }

   const render = ({item}) => {
      return (
         <AdevertisementItem
            item={item}
            navigation={navigation}
            posterWidth={posterWidth}
         />
      );
   };

   useEffect(() => {
      (async () => {
         if ((isWindows && isScreenFocused) || !isWindows) {
            getAdvertisementDataFromAPI();
         }
      })();
      return () => {};
   }, []);

   const placeHolderData = [
      //Below data is used when api gives blank array of records
      {
         Image: 'scooptrams-on-surface.jpg',
         Link: 'https://cdn.norcat.org/assets/img/underground-centre/gallery/',
      },
      {
         Image: 'underground-centre-tour.jpg',
         Link: 'https://cdn.norcat.org/assets/img/underground-centre/gallery/',
      },
      // Add more poster data as needed
   ];
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const handleLayout = event => {
      const {width} = event.nativeEvent.layout;
      if (isWindows) {
         setPosterWidth(width);
      }
   };
   return (
      <View
         onLayout={handleLayout}
         style={{
            flex: 1,
            backgroundColor: 'white',
            ...Platform.select({
               web: {
                  maxHeight: '190vh',
                  height: isLandscapeMode ? '93.5vh' : null,
                  flex: isLandscapeMode ? null : 1,
                  backgroundColor: appBackgroundWhiteBG,
               },
            }),
         }}>
         {props.showName ? (
            <View
               style={{
                  backgroundColor: primaryState500,
                  paddingHorizontal: 20,
                  justifyContent: 'center',
                  height: 72,
                  ...Platform.select({
                     web: {
                        maxHeight: isLandscapeMode ? '14%' : null,
                        minHeight: isLandscapeMode ? '8vh' : null,
                        paddingVertical: isLandscapeMode ? '1vh' : null,
                        display: 'flex',
                        justifyContent: 'center',
                        height: 72,
                     },
                     android: {
                        height: isLandscapeMode ? 72 : null,
                     },
                  }),
               }}>
               <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  style={{
                     color: white,
                     fontSize: 20,
                     fontWeight: '700',
                     fontFamily: FONT_FAMILY_REGULAR,
                     width: '100%',
                     alignSelf: 'stretch',
                     //maxWidth: 320,
                  }}>
                  {getFullName(props.authData)}
               </Text>
            </View>
         ) : null}

         <View
            style={{
               height: 117,
               backgroundColor: '#ffffff',
               paddingHorizontal: 20,
               //paddingVertical: 16,
               flexDirection: 'row',
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               ...Platform.select({
                  web: {
                     //maxHeight: isLandscapeMode ? '18vh' : '20vh',
                     //minHeight: isLandscapeMode ? '18vh' : null,
                     /* display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center', */
                     /* paddingVertical:
                        Dimensions.get('window').height < 540
                           ? 0
                           : isLandscapeMode
                           ? '1vh'
                           : 16, */
                  },
               }),
            }}>
            {/* NORCAT ID  */}
            <View
               style={{
                  flexDirection: 'column',
                  flex: 4,
               }}>
               <Text
                  numberOfLines={Platform.OS === 'web' ? 1 : null}
                  ellipsizeMode={Platform.OS === 'web' ? 'tail' : null}
                  style={{
                     color: '#000000',
                     fontSize: 16,
                     fontWeight: '700',
                     fontFamily: FONT_FAMILY_REGULAR,
                     position: 'absolute',
                     opacity: 0.6,
                  }}>
                  NORCAT ID
               </Text>
               <Text
                  numberOfLines={Platform.OS === 'web' ? 1 : null}
                  ellipsizeMode={Platform.OS === 'web' ? 'tail' : null}
                  style={{
                     color: '#202020',
                     fontSize: 40,
                     fontWeight: '700',
                     fontFamily: FONT_FAMILY_REGULAR,
                     paddingTop: 11,
                  }}>
                  {getNorcatId(props.authData)}
               </Text>
            </View>
            {/* QR Code  */}
            <View
               style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#FFF',
                  paddingHorizontal: 7,
                  paddingVertical: 7,
               }}>
               {/* <Pulse /> */}
               <TouchableOpacity
                  onPress={() => {
                     props.onQrClick();
                  }}
                  style={{
                     alignItems: 'center',
                  }}>
                  <Image
                     source={{
                        uri:
                           'data:image/jpeg;base64,' +
                           getQRCode(props.authData),
                     }}
                     //style={{height: 72, width: 72}}
                     style={{height: 62, width: 62}}
                  />
                  <ViewBarcode />
               </TouchableOpacity>
            </View>
         </View>
         {props.showProgressView ? (
            <ProgressBar
               isLandscapeMode={isLandscapeMode}
               percent={parseInt(overAllPercent(props.showPercentageData))}
            />
         ) : null}
         {/** Replace dynamic image advertisement link on below image uri */}
         {/** Link taken from https://www.norcat.org/underground-centre/gallery.html */}
         {/*<View style={{padding: 8, backgroundColor: white,}}>
        <Image
          style={{width: '100%', height: 200}}
          resizeMode="cover"
          source={{
            uri: 'https://cdn.norcat.org/assets/img/underground-centre/gallery/scooptrams-on-surface.jpg',
          }}></Image>
        <Image
          style={{width: '100%', height: 200, marginTop: 8}}
          resizeMode="cover"
          source={{
            uri: 'https://cdn.norcat.org/assets/img/underground-centre/gallery/underground-centre-tour.jpg',
          }}></Image>
      </View>*/}
         <View
            style={[
               styles.advertiseContainer,
               {
                  ...Platform.select({
                     web: {
                        // maxHeight: props?.maxHeight ? props?.maxHeight : null,
                        // minHeight: isLandscapeMode
                        //    ? '100%'
                        //       ? props?.maxHeight
                        //       : null
                        //    : null,
                        height: posterHeight,
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        marginHorizontal: 0,
                        marginVertical: 0,
                     },
                  }),
               },
            ]}>
            <FlatList
               style={{
                  marginTop: 8,
                  // marginBottom: !isWindows ? (!isMobile ? 8 : null) : null,
               }}
               data={advertisementList}
               renderItem={render}
               keyExtractor={item => item.Image}
               numColumns={1}
               contentContainerStyle={styles.contentContainer}
            />
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   contentContainer: {
      paddingTop: 0,
   },
   advertiseContainer: {
      flex: 1,
      ...Platform.select({
         web: {
            flex: null,
         },
      }),
   },
});
export default DashboardRightPanel;
